import { toast, type ToastTheme } from "vue3-toastify";
import { useColorMode } from "@vueuse/core";
import { ref } from "vue";
import type { UseNotify } from "@/shared/interfaces/notify";

const { state } = useColorMode({
  initialValue: "light",
});

const themeSystem = ref({
  light: "light",
  dark: "dark",
});

export const useNotify = ({
  message,
  type = "success",
  theme = themeSystem.value[state.value] as ToastTheme,
  position = "top-right",
  transition = "flip",
}: UseNotify) => {
  toast(message, {
    type: type,
    theme: theme,
    position: position,
    transition: transition,
    autoClose: 2000,
    pauseOnHover: true,
    clearOnUrlChange: false,
  } as UseNotify);
};
